import { render, staticRenderFns } from "./KanbanBoardColumn.vue?vue&type=template&id=1631dcf9&"
import script from "./KanbanBoardColumn.vue?vue&type=script&lang=js&"
export * from "./KanbanBoardColumn.vue?vue&type=script&lang=js&"
import style0 from "./KanbanBoardColumn.vue?vue&type=style&index=0&id=1631dcf9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports